/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_COSTUME_TYPE } from "../graphql/getCostumeFeatures.query";
import { PREBOOKED_AMT } from "../graphql/preBooked.query";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetPreBookedAmtMethods extends IPluginMethodMap {
  getPreBookedAmt(): Promise<any>;
}

export class GetPreBookedAmtService implements IAgentPlugin {
  readonly methods: IGetPreBookedAmtMethods;
  private exchangeRate: any = 1;

  constructor() {
    this.methods = {
      getPreBookedAmt: this.getPreBookedAmt.bind(this),
    };
  }

  async getPreBookedAmt() {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.query({
          query: PREBOOKED_AMT,
          variables: {},
          fetchPolicy: "network-only",
        });
        if (res?.data?.getMyPreBookedBox?.amountPaid) {
          return {
            preBookedAmt: res?.data?.getMyPreBookedBox?.amountPaid,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
